import Link from 'next/link';
import type { MenuItemData } from '@/types/public-menu';
import { getContextualHref } from '@/lib/domains';
type GroceryFields = MenuItemData & { mrp?: number | string; brand?: string; packSize?: string };
import { fromPriceOf, hasVariants, listPriceOf, priceOf, sized } from '../grocery-utils';

export const mrpOf = (i: MenuItemData): number | null => {
  const m = Number((i as GroceryFields).mrp);
  return m > priceOf(i) ? m : null;
};

function Tile({ item, slug, sym }: { item: MenuItemData; slug: string; sym: string }) {
  const variants = hasVariants(item);
  const was = variants ? null : item.markdownPct ? listPriceOf(item) : mrpOf(item);
  const brand = (item as GroceryFields).brand;
  const pack = (item as GroceryFields).packSize;
  return (
    <Link href={getContextualHref(slug, `/product/${item.id}`)} className="gh-tile gh-prod">
      <div className="gh-prod-img">
        {item.imageUrl && <img src={sized(item.imageUrl, 360)} alt="" loading="lazy" decoding="async" />}
        {item.markdownPct ? <span className="gh-pill">{item.markdownPct}% off</span> : null}
      </div>
      <div style={{ padding: '8px 10px 12px' }}>
        {brand && <div className="gh-brand">{brand}</div>}
        <div className="gh-prod-name">{item.name}</div>
        {pack && <div className="gh-brand" style={{ textTransform: 'none' }}>{pack}</div>}
        <div style={{ marginTop: 4, display: 'flex', alignItems: 'baseline', gap: 6 }}>
          <strong>{variants && <span style={{ fontWeight: 500, fontSize: '0.7rem', color: 'var(--color-text-muted)' }}>From </span>}{sym}{fromPriceOf(item).toFixed(2)}{item.soldByWeight ? `/${(item.weightUnit ?? 'KG').toLowerCase()}` : ''}</strong>
          {was && <s style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)' }}>{sym}{was.toFixed(2)}</s>}
        </div>
      </div>
    </Link>
  );
}

export function ProductRow({ title, hint, items, slug, sym }: { title: string; hint?: string; items: MenuItemData[]; slug: string; sym: string }) {
  if (!items.length) return null;
  return (
    <section aria-label={title} className="gh-wrap gh-section">
      <div className="gh-head">
        <div>
          <h2 className="gh-h2">{title}</h2>
          {hint && <p style={{ margin: '2px 0 0', fontSize: '0.82rem', color: 'var(--color-text-muted)' }}>{hint}</p>}
        </div>
        <Link href={getContextualHref(slug, '/menu')} className="gh-link">See all</Link>
      </div>
      <div className="gh-scroll">
        {items.map((i) => <Tile key={i.id} item={i} slug={slug} sym={sym} />)}
      </div>
    </section>
  );
}
